export const MultilineTextFieldDefaults = {
    DEFAULT_ROWS: 2,
    MAX_ROWS: 10,
};
